module.exports = __webpack_public_path__ + "media/images/web_suite/icon_flashcards-1e63d669b2aa5ad270dd3f442ed867f4.png";